import { Avatar, Badge, Table } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { colorAvatarByName } from '@/common/utils/colorAvatarByName'
import { formatCPF } from '@/common/utils/formatCPF'
import { translateUserType } from '@/common/utils/translateUserType'
import { UserPaginated } from '../hooks/usePaginateUsers'
import { UserActiveActions } from './UserActiveActions'
import { UserInactiveActions } from './UserInactiveActions'

type UserTableRowProps = {
  user: UserPaginated
}

export function UserTableRow({ user }: UserTableRowProps) {
  const { t } = useTranslation(['common', 'registers'])

  return (
    <Table.Row hideCheckbox id={user?.id}>
      <Table.Data className="flex gap-3">
        <Avatar
          src={user?.UserPreference?.avatarUrl || ''}
          name={user?.Person?.name}
          color={colorAvatarByName(user?.Person?.name || '')}
        />

        <div className="flex flex-col justify-center mb-1">
          <span className="text-base-800 font-medium text-sm">
            {user?.Person?.name}
          </span>

          <span className="text-base-400 font-light text-sm">
            {user?.Person?.isForeign
              ? user?.Person?.documentNumber || ''
              : formatCPF(user?.Person?.documentNumber)}
          </span>
        </div>
      </Table.Data>

      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-light text-sm">{user?.email}</span>
      </Table.Data>

      <Table.Data>
        <Badge.Root shape="square" className="w-full flex justify-center ">
          {translateUserType(t, user?.userType)}
        </Badge.Root>
      </Table.Data>

      <Table.Data end>
        {user.isActive && <UserActiveActions user={user} />}
        {!user.isActive && <UserInactiveActions user={user} />}
      </Table.Data>
    </Table.Row>
  )
}
